import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const addCardFormStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: theme.typography.fontFamily,
  } as CSSProperties,

  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.large,
    paddingBottom: theme.spacing.giant,
  } as CSSProperties,

  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.medium,
  } as CSSProperties,

  backButton: {
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: 0,
    color: theme.colors.button.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.normal,
  } as CSSProperties,

  title: {
    margin: 0,
    color: theme.colors.label,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.tiny,
  } as CSSProperties,

  fieldLabel: {
    display: 'block',
    fontFamily: theme.typography.fontFamily,
    color: theme.colors.label,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: theme.typography.lineHeight.sm,
    margin: 0,
  } as CSSProperties,

  textInput: {
    width: '100%',
    boxSizing: 'border-box',
    padding: `${theme.spacing.mediumSmall}px ${theme.spacing.small}px`,
    height: 36,
    border: `1px solid ${theme.colors.inputBorder}`,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.inputBg,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: theme.typography.lineHeight.base,
    color: theme.colors.inputText,
    outline: 'none',
  } as CSSProperties,

  expiryAndCvvRow: {
    display: 'flex',
    gap: theme.spacing.medium,
  } as CSSProperties,

  expiryGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.tiny,
    flex: 1,
  } as CSSProperties,

  expirySelectRow: {
    display: 'flex',
    gap: theme.spacing.small,
  } as CSSProperties,

  expirySelect: {
    flex: 1,
    minWidth: 0,
    boxSizing: 'border-box',
    height: 36,
    padding: '0 28px 0 12px',
    border: `1px solid ${theme.colors.inputBorder}`,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.inputBg,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    lineHeight: '34px',
    color: theme.colors.inputText,
    outline: 'none',
    appearance: 'none',
    WebkitAppearance: 'none',
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='none' stroke='%23747474' stroke-width='1.5' d='M1 1.5l5 5 5-5'/%3E%3C/svg%3E\")",
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 10px center',
    backgroundSize: '12px 8px',
  } as CSSProperties,

  cvvGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.tiny,
    flex: 1,
  } as CSSProperties,

  actions: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.small,
    padding: `${theme.spacing.medium}px ${theme.spacing.medium}px`,
    backgroundColor: theme.colors.background,
    boxShadow: '0px -8px 12px -4px rgba(0, 0, 0, 0.08)',
  } as CSSProperties,

  cancelButton: {
    width: '100%',
    boxSizing: 'border-box',
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    border: `1px solid ${theme.colors.button.primary}`,
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.white,
    color: theme.colors.button.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    cursor: 'pointer',
  } as CSSProperties,

  saveButton: {
    width: '100%',
    boxSizing: 'border-box',
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    border: 'none',
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.button.primary,
    color: theme.colors.white,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    cursor: 'pointer',
    transition: `background-color ${theme.transitions.fast}`,
  } as CSSProperties,

  sheetCard: {
    backgroundColor: 'transparent',
    padding: 0,
  } as CSSProperties,

  sheetColumns: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  } as CSSProperties,

  sheetFields: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  } as CSSProperties,

  sheetHeader: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 28,
    marginBottom: theme.spacing.medium,
  } as CSSProperties,

  sheetClose: {
    position: 'absolute',
    right: 0,
    top: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: 4,
    color: theme.colors.palette.darkGrey200,
    display: 'flex',
  } as CSSProperties,

  inlineCard: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.radius.md,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.large,
    padding: theme.spacing.medium,
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
  } as CSSProperties,

  inlineHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing.medium,
    height: '37px',
  } as CSSProperties,

  inlineTitle: {
    margin: 0,
    color: theme.colors.palette.darkGrey200,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.lg,
    lineHeight: theme.typography.lineHeight.lg,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  inlineCancel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: 0,
    color: theme.colors.button.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.lg,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  inlineColumns: {
    display: 'grid',
    gridTemplateColumns: 'minmax(312px, 280px) minmax(0, 1fr)',
    gap: 24,
    alignItems: 'start',
  } as CSSProperties,

  inlineFields: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.medium,
  } as CSSProperties,

  webLabel: {
    display: 'block',
    margin: 0,
    color: theme.colors.palette.darkGrey200,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: '20px',
    fontWeight: theme.typography.fontWeight.normal,
  } as CSSProperties,

  webInput: {
    width: '100%',
    boxSizing: 'border-box',
    height: 40,
    margin: 0,
    padding: '8px 12px',
    border: `1px solid ${theme.colors.palette.grey300}`,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.white,
    color: theme.colors.palette.darkGrey200,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: '20px',
    fontWeight: theme.typography.fontWeight.normal,
    outline: 'none',
  } as CSSProperties,

  inputError: {
    borderColor: theme.colors.error,
  } as CSSProperties,

  fieldErrorText: {
    margin: 0,
    color: theme.colors.error,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.xs,
    lineHeight: theme.typography.lineHeight.sm,
  } as CSSProperties,

  formNotice: {
    padding: `${theme.spacing.small}px ${theme.spacing.mediumSmall}px`,
    backgroundColor: theme.colors.palette.lightBlue100,
    border: `1px solid ${theme.colors.palette.lightBlue200}`,
    borderRadius: theme.radius.sm,
  } as CSSProperties,

  formNoticeText: {
    margin: 0,
    color: theme.colors.palette.darkGrey200,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.sm,
  } as CSSProperties,

  inlineSave: {
    width: '100%',
    boxSizing: 'border-box',
    height: 40,
    border: 'none',
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.button.primary,
    color: theme.colors.white,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.base,
    lineHeight: '24px',
    fontWeight: theme.typography.fontWeight.bold,
    cursor: 'pointer',
  } as CSSProperties,

  saveButtonMuted: {
    backgroundColor: theme.colors.palette.blue700,
    cursor: 'not-allowed',
  } as CSSProperties,
};
